import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RequiredAsteriskDirective } from '@core/directive/required-asterisk.directive';
import { ICompletion } from '@core/interfaces/interface';
import { PasswordValidator } from '@core/validators/password.validator';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-create-password-form',
  imports: [TranslocoModule, ReactiveFormsModule, RouterModule,RequiredAsteriskDirective],
  templateUrl: './create-password-form.component.html',
  styleUrl: './create-password-form.component.scss',
})
@UntilDestroy()
export class CreatePasswordFormComponent {
  public form!: FormGroup;
  public passwordChecked: boolean = false;
  public checkedSpiner: boolean = false;
  private token: string = '';
  @Input() title: string = '';
  @Input() success: boolean = false;
  @Output() submitForm: EventEmitter<ICompletion> =
    new EventEmitter<ICompletion>();

  constructor(private fb: FormBuilder, private route: ActivatedRoute) {
    this.route.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    this.reactiveForm();
  }

  private passwordsMatch(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('repeat_password')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  public submit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitForm.emit({
      password: this.password.value,
      token: String(this.token),
    });
  }

  private reactiveForm() {
    this.form = this.fb.group(
      {
        password: [null, [Validators.required, PasswordValidator.validate]],
        repeat_password: [null, Validators.required],
      },
      { validators: this.passwordsMatch }
    );
  }

  public get password(): FormControl {
    return (<FormControl>this.form.get('password')) as FormControl;
  }

  public get repeat_password(): FormControl {
    return (<FormControl>this.form.get('repeat_password')) as FormControl;
  }
}
